import React from 'react';
import { Button } from 'antd';
import { ReactComponent as GeocloudLogo } from '~/assets/svg/geocloud_logo.svg';
import SwitcherLng from '~/components/common/SwitcherLng';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Routes from '~/routes/routes';

interface LandingHeaderProps {
    onNavigateToProjects?: () => void;
    logoUrl?: string;
}

const LandingHeader: React.FC<LandingHeaderProps> = ({
    onNavigateToProjects,
    logoUrl,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleNavigate = () => {
        if (onNavigateToProjects) {
            onNavigateToProjects();
        } else {
            navigate(Routes.PROJECT);
        }
    };

    return (
        <div
            style={{
                position: 'relative',
                zIndex: 10,
                padding: '12px 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: 'rgba(0,0,0,0.2)',
                backdropFilter: 'blur(10px)',
                borderBottom: '1px solid rgba(255,255,255,0.08)',
                flexWrap: 'wrap',
                gap: 12,
            }}
        >
            {/* Logo - sử dụng logo chính thức từ assets + text xếp hàng ngang */}
            <div style={{ display: 'flex', alignItems: 'center', flex: '1 1 auto' }}>
                {logoUrl ? (
                    <img
                        src={logoUrl}
                        alt="Geocloud"
                        style={{ height: 32, marginRight: 6 }}
                    />
                ) : (
                    <GeocloudLogo style={{ height: 32, marginRight: 6 }} />
                )}
                <span style={{ fontWeight: 700, fontSize: '1rem', color: '#fff', marginRight: 2 }}>
                    GeoCloud
                </span>
                <span style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)' }}>
                    - Cloud Native GIS
                </span>
            </div>

            {/* Actions: LanguageSelector + Vào ứng dụng button */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    flexWrap: 'wrap',
                    justifyContent: 'flex-end',
                }}
            >
                {/* Language Selector */}
                <div style={{ color: '#fff' }}>
                    <SwitcherLng
                        style={{
                            background: 'rgba(255,255,255,0.1)',
                            padding: '4px 8px',
                            borderRadius: 6,
                            border: '1px solid rgba(255,255,255,0.2)',
                        }}
                    />
                </div>

                <Button
                    type="primary"
                    style={{
                        background: 'linear-gradient(135deg, #69c0ff, #d3adf7)',
                        border: 'none',
                        color: '#000',
                        fontWeight: 600,
                    }}
                    onClick={handleNavigate}
                >
                    {t('landing__btn_enter_app')}
                </Button>
            </div>
        </div>
    );
};

export default LandingHeader;
